import ScrollReveal from "../../../components/feature/ScrollReveal";
import { policyData } from "../../../mocks/giftData";

export default function PolicySection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-2">{policyData.label}</p>
              <h2 className="section-title">{policyData.title}</h2>
              <p className="section-subtitle max-w-2xl mx-auto">
                {policyData.description}
              </p>
            </div>
          </ScrollReveal>

          <div className="space-y-5">
            {policyData.policies.map((p, idx) => (
              <ScrollReveal key={p.title} direction="up" delay={idx * 100}>
                <div className="bg-airdoa-cream rounded-lg overflow-hidden border border-airdoa-gray-light/30">
                  <div className="bg-airdoa-navy/5 px-5 py-3 md:px-6 md:py-4">
                    <h3 className="text-base font-serif font-semibold text-airdoa-navy">
                      {p.title}
                    </h3>
                  </div>
                  <div className="p-5 md:p-6">
                    <ul className="space-y-2.5">
                      {p.items.map((item, i) => (
                        <li
                          key={i}
                          className="flex items-start gap-2 text-sm text-airdoa-gray"
                        >
                          <span className="w-4 h-4 flex items-center justify-center text-airdoa-gold mt-0.5 shrink-0">
                            <i className="ri-arrow-right-s-line" />
                          </span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}